import { render } from "./controlRecords.vue?vue&type=template&id=f991daf6"
import script from "./controlRecords?vue&type=script&lang=js"
export * from "./controlRecords?vue&type=script&lang=js"

import "./controlRecords.vue?vue&type=style&index=0&id=f991daf6&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__